import axios from "axios";
import { Config } from "../Config";
import { userAccessToken } from "../helpers";

// Potential revenue
export const potentialRevenue = async (account_id,location_id) => {
  try {
    const response = axios.get(
      `${Config.apiServerUrl}/audit/dashboard/read?account_id=${account_id}&location_id=${location_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const updatePotentialRevenue = async (data) => {
  try {
    const response = await axios.post(`${Config.apiServerUrl}/audit/dashboard/write`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

// Precision Coding and Billing
export const codingAndBillingData = async (account_id,location_id) => {
  try {
    const response = axios.get(`${Config.apiServerUrl}/audit/precision_coding_and_billing/read?account_id=${account_id}&location_id=${location_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const updateCodingAndBillingData = async (data) => {
  try {
    const response = await axios.post(`${Config.apiServerUrl}/audit/precision_coding_and_billing/write`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

// Patient Retention
export const patientRetentions = async (account_id,location_id) => {
  try {
    const response = axios.get(`${Config.apiServerUrl}/audit/patient_retention/read?account_id=${account_id}&location_id=${location_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const updatePatientRetentions = async (data) => {
  try {
    const response = await axios.post(`${Config.apiServerUrl}/audit/patient_retention/write`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

// Chronic Care Management
export const chronicCare = async (account_id,location_id) => {
  try {
    const response = axios.get(`${Config.apiServerUrl}/audit/chronic_care_management/read?account_id=${account_id}&location_id=${location_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const updateCareManagement = async (data) => {
  try {
    const response = await axios.post(`${Config.apiServerUrl}/audit/chronic_care_management/write`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

// Quality Incentive Payment
export const qualityIncentivePayment = async (account_id,location_id) => {
  try {
    const response = axios.get(`${Config.apiServerUrl}/audit/quality_incentive_payment/read?account_id=${account_id}&location_id=${location_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const updateQualityIncentivePayment = async (data) => {
  try {
    const response = await axios.post(`${Config.apiServerUrl}/audit/quality_incentive_payment/write`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

// Maximizing Preventive Care
export const maximizingPreventiveCare = async (account_id,location_id) => {
  try {
    const response = axios.get(`${Config.apiServerUrl}/audit/maximizing_preventive_care/read?account_id=${account_id}&location_id=${location_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const updateMaximizingPreventiveCare = async (data) => {
  try {
    const response = await axios.post(`${Config.apiServerUrl}/audit/maximizing_preventive_care/write`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

// Transitional Care Management
export const transitionalCare = async (account_id,location_id) => {
  try {
    const response = axios.get(`${Config.apiServerUrl}/audit/transitional_care_management/read?account_id=${account_id}&location_id=${location_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const updateTransitionalCare = async (data) => {
  try {
    const response = await axios.post(`${Config.apiServerUrl}/audit/transitional_care_management/write`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};